import apiCall from './apiCall';

const getAllInspectionEmails = async (param: any) => {
    const query = `?search=${param.search || ''}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/InspectionEmails/GetAllInspectionEmails${query}`;
    return apiCall('get', URL);
};

const getInspectionEmailById = async (id: string) => {
    const URL = `/InspectionEmails/GetInspectionEmailById/${id}`;
    return apiCall('get', URL);
};

const resendInspectionEmail = async (data: any) => {
    const URL = '/InspectionEmails/Resend';
    return apiCall('post', URL, data);
};

export {
    getAllInspectionEmails,
    getInspectionEmailById,
    resendInspectionEmail,
};
